const systemBaseUrl = '/api/user'
const clientBaseUrl = '/api/customer/user'

export default {
    get: (id) => {
        return axios.get(`${systemBaseUrl}s/${id}`)
    },
    search: (search) => {
        const cancelTokenSource = axios.CancelToken.source()

        const config = {
            cancelToken: cancelTokenSource.token,
        }

        return {
            promise: axios.get(`${clientBaseUrl}/search/${encodeURIComponent(search)}`, config),
            cancel: () => cancelTokenSource.cancel(),
        }
    },
}
